import { clsx } from 'clsx';
import type { RecipientStatus, ReferralStatus, Urgency } from '../api/referralsApi';
import patterns from '@/shared/ui/styles/patterns.module.css';
import { RECIPIENT_STATUS_LABEL, STATUS_LABEL } from './statusLabels';

const STATUS_CLASS: Record<ReferralStatus, string> = {
  draft: patterns.pillMuted,
  sent: patterns.pillInfo,
  viewed: patterns.pillInfo,
  scheduled: patterns.pillAccent,
  completed: patterns.pillSuccess,
  declined: patterns.pillError,
  cancelled: patterns.pillMuted,
};

export function ReferralStatusPill({ status }: { status: ReferralStatus }) {
  return <span className={clsx(patterns.pill, STATUS_CLASS[status])}>{STATUS_LABEL[status]}</span>;
}

const RECIPIENT_CLASS: Record<RecipientStatus, string> = {
  pending: patterns.pillMuted,
  sent: patterns.pillInfo,
  viewed: patterns.pillInfo,
  scheduled: patterns.pillAccent,
  completed: patterns.pillSuccess,
  declined: patterns.pillError,
  superseded: patterns.pillMuted,
  cancelled: patterns.pillMuted,
};

export function RecipientStatusPill({ status }: { status: RecipientStatus }) {
  return <span className={clsx(patterns.pill, RECIPIENT_CLASS[status])}>{RECIPIENT_STATUS_LABEL[status]}</span>;
}

export function UrgencyPill({ urgency, prefix }: { urgency: Urgency; prefix?: string }) {
  if (urgency === 'routine') return null;
  return (
    <span className={clsx(patterns.pill, urgency === 'urgent' ? patterns.pillError : patterns.pillWarning)}>
      {prefix}
      {urgency === 'urgent' ? 'Urgent' : 'Soon'}
    </span>
  );
}
